import { useCallback, useEffect, useRef, useState } from "react";
import ReactGA from "react-ga4";

export type AnalyticsEvent =
  | { type: "login"; method: string }
  | { type: "apply_job_begin"; id: number; name: string; location: string }
  | { type: "apply_job_complete"; id: number; name: string; location: string }
  | { type: "apply_job_cv"; id: number; name: string; location: string }
  | { type: "apply_job_end"; id: number; name: string; location: string }
  | { type: "apply_job_files"; id: number; name: string; location: string }
  | { type: "apply_job_payment"; id: number; name: string; location: string; payment: string }
  | { type: "apply_job_select_candidate"; id: number; name: string; location: string }
  | { type: "apply_job_work_styles_complete"; id: number; name: string; location: string }
  | { type: "save_job"; id: number; name: string; location: string }
  | { type: "search"; search_term: string }
  | { type: "share_job"; id: number; name: string; location: string; method: string }
  | { type: "sign_up" };

export interface UseAnalyticsReturn {
  sendEvent: (event: AnalyticsEvent) => void;
}

export const useAnalytics = (): UseAnalyticsReturn => {
  const firstRender = useRef(true);

  const [initialized, setInitialized] = useState(false);

  const sendEvent = useCallback(
    (event: AnalyticsEvent) => {
      if (initialized) {
        const { type, ...restEvent } = event;
        ReactGA.event(type, restEvent);
      }
    },
    [initialized],
  );

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;

      const { __ANALYTICS_KEY__ } = window;

      if (__ANALYTICS_KEY__ && __ANALYTICS_KEY__ !== "<ANALYTICS_KEY>") {
        ReactGA.initialize(__ANALYTICS_KEY__);
        setInitialized(true);
      }
    }
  }, []);

  return {
    sendEvent,
  };
};
